import type { MutationUpdateAccountNameArgs } from '@/generated/gql/graphql'
import { invalidateCache } from '../utils/invalidateCache'

const cacheInvalidateUpdaters = {}
const cacheInvalidateMutationsList = [
    'unarchiveGroup',
    'archiveGroup',
    'unStarGroup',
    'starGroup',
    'transferGroupOwnership',
    'resendUserInvitation',
    'deleteGroupV1',
]

cacheInvalidateMutationsList.forEach((mutation) => {
    cacheInvalidateUpdaters[mutation] = (result, args, cache) => {
        invalidateCache(cache, 'group')
        invalidateCache(cache, 'groupsV1')
    }
})

const groupsUpdaters = {
    editGroupV1: (result, args, cache) => {
        invalidateCache(cache, 'group')
    },
    updateAccountName: (
        _result,
        args: MutationUpdateAccountNameArgs,
        cache,
    ) => {
        const { id } = args.input
        cache.invalidate({
            __typename: 'User',
            id,
        })
    },
    ...cacheInvalidateUpdaters,
}

export { groupsUpdaters }
